import React from "react";
import "./PageSearch.scss";
import { useTranslation, withTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { searchState } from "recoil/commonUiAtom";

function PageSearch() {
  const { t } = useTranslation();
  const [searchVal, setSearchVal] = useRecoilState(searchState);
  const getSearchVal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchVal(e.currentTarget.value);
  };

  return (
    <div className="search">
      <div className="open-search-bg">
        <label htmlFor="searchPage" className="hidden" />
        <input
          className="page-search"
          id="searchPage"
          type="text"
          maxLength={20}
          placeholder={t("Enter_title_content")}
          value={searchVal}
          onChange={(e) => getSearchVal(e)}
        />
      </div>

      <button className="page-search-btn pc" />
    </div>
  );
}

export default withTranslation()(PageSearch);
